import { render, staticRenderFns } from "./zeDialog.vue?vue&type=template&id=7987995a&scoped=true"
import script from "./zeDialog.vue?vue&type=script&lang=js"
export * from "./zeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7987995a",
  null
  
)

export default component.exports